import { TaskStatus } from "Static/@cortex/messages/enums/task_status_pb";
import { MESSAGE_LEVEL_MAP, TASK_STATUS_MAP } from "constant/protobuf";
import {
  addErrorMessageAction,
  addMessageAction,
  addSuccessMessageAction,
  LEVEL_INFO,
} from "redux-store/messages";

import { payloadRouter } from "./proto-utils";

function errorsToHtmlStr(errorsList = []) {
  return errorsList.reduce((acc, e) => {
    acc += `<li>${e}</li>`;

    return acc;
  }, "");
}

/*
 * You must bind a refreshMessage to consume this handler.
 * Do not use directly.
 */
function _genericTaskResult(refreshMessage, taskResult) {
  const status = TASK_STATUS_MAP[taskResult.status];
  // Don't need get. `name` defaults to ''.
  const taskName = taskResult.source.name || "Your";
  const { errorsList } = taskResult;

  if (taskResult.status === TaskStatus.FAILURE) {
    const errors = errorsToHtmlStr(errorsList);
    const errorsHtml = errors ? ` <ul>${errors}</ul>` : "";

    return addErrorMessageAction(
      `${taskName} task has ${status}.${errorsHtml}`,
    );
  }

  if (taskResult.status === TaskStatus.SUCCESS) {
    let successMsg = `${taskName} task has ${status}.`;
    if (refreshMessage) {
      successMsg = `${successMsg} ${refreshMessage}`;
    }

    return addMessageAction(LEVEL_INFO, successMsg);
  }

  return addSuccessMessageAction(`${taskName} task has ${status}.`);
}

function bulkDeviceMessage(message) {
  const level = MESSAGE_LEVEL_MAP[message.level];

  return addMessageAction(level, message.message);
}

const bulkDeviceTaskResult = _genericTaskResult.bind(
  null,
  "Please refresh to see the updated devices.",
);

function bulkDeviceHandler(emitter, message) {
  const handlers = {
    message: bulkDeviceMessage,
    taskResult: bulkDeviceTaskResult,
  };

  const action = payloadRouter(message, handlers);

  if (action) {
    return emitter(action);
  }
}

const genericTaskResult = _genericTaskResult.bind(null, null);

function genericTaskHandler(emitter, message) {
  const handlers = {
    taskResult: genericTaskResult,
  };

  const action = payloadRouter(message, handlers);

  if (action) {
    return emitter(action);
  }
}

export {
  bulkDeviceHandler,
  bulkDeviceMessage,
  bulkDeviceTaskResult,
  genericTaskHandler,
  genericTaskResult,
};
